import React from 'react'

import { Marquee } from '@/components/shared/Marquee'

import styles from './styles.module.css'

const TitleMarquee = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className={styles.title__marquee}>
      <Marquee className="[--duration:10s] [--gap:10rem]">
        <h3 className={styles.title__marquee__text}>{children}</h3>
      </Marquee>
    </div>
  )
}

export default TitleMarquee
